var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-697.000000, -331.000000)",
    stroke: "#00A0CE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.83871,37.7407407 C370.83871,42.0155648 374.334048,45.4814815 378.645161,45.4814815 C379.964536,45.4814815 381.207506,45.156861 382.297262,44.5837805 C381.483871,38.4444444 386.451613,36.3333333 386.330122,36.3730504 C385.678705,32.7504646 382.485622,30 378.645161,30 C374.334048,30 370.83871,33.4659167 370.83871,37.7407407 Z M368,61.3703704 L368,58.7901235 C368,48.4691358 373.96129,45.8888889 377.935484,45.8888889 C380.882469,45.8888889 384.922093,47.3076819 386.813456,52.2494239 M393.653849,36.465434 C395.677419,37.7407407 398.516129,40.5555556 397.607555,44.5328826 C400.026563,45.8479837 399.996891,45.4814815 401.354839,45.4814815 C405.665952,45.4814815 409.16129,42.0155648 409.16129,37.7407407 C409.16129,33.4659167 405.665952,30 401.354839,30 C397.481797,30 394.267164,32.7973296 393.653849,36.465434 Z M393.234553,52.1259066 C395.145547,47.2839982 399.142232,45.8888889 402.064516,45.8888889 C406.03871,45.8888889 412,48.4691358 412,58.7901235 L412,61.3703704 M382.193548,43.1296296 C382.193548,47.2715046 385.551673,50.6296296 389.693548,50.6296296 C393.835423,50.6296296 397.193548,47.2715046 397.193548,43.1296296 C397.193548,38.9877546 393.835423,35.6296296 389.693548,35.6296296 C385.551673,35.6296296 382.193548,38.9877546 382.193548,43.1296296 Z M379.354839,67 L379.354839,64.4197531 C379.354839,54.0987654 385.741935,51.5185185 390,51.5185185 C394.258065,51.5185185 400.645161,54.0987654 400.645161,64.4197531 L400.645161,67",
    style: {
      mixBlendMode: "darken"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.31f54816227a81ba081d9c39aed6730d.svg";
export { ForwardRef as ReactComponent };